/**
 * The favorites shelf's kind filter (#2293): All / Models / Documents /
 * Functionals, applied on the client to the list already loaded.
 */
import { FAVORITE_FILTERS, type FavoriteFilter } from './favorites';

export default function FavoriteKindChips({ value, onChange }: Readonly<{
  value: FavoriteFilter;
  onChange: (value: FavoriteFilter) => void;
}>) {
  return (
    <fieldset aria-label="Show favorites of kind" className="flex flex-wrap gap-1.5 mb-3 min-w-auto">
      {FAVORITE_FILTERS.map((f) => {
        const active = f.value === value;
        return (
          <button
            key={f.value}
            type="button"
            aria-pressed={active}
            onClick={() => onChange(f.value)}
            style={{
              padding: '5px 12px',
              borderRadius: 999,
              fontSize: 12,
              fontWeight: 700,
              cursor: 'pointer',
              transition: 'all 0.2s ease',
              background: active ? 'rgb(var(--brew-blue-light) / 0.2)' : 'rgba(10, 16, 30, 0.6)',
              border: `1px solid rgb(var(--brew-blue-light) / ${active ? 0.45 : 0.14})`,
              color: active ? '#d4eaf5' : 'rgb(var(--aurora-text-muted) / 0.75)',
            }}
          >
            {f.label}
          </button>
        );
      })}
    </fieldset>
  );
}
